import { render } from "./Plan.vue?vue&type=template&id=40af5000&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=40af5000&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40af5000"]])

export default __exports__